import { EDataTestId } from '@aqx-core/common/data-test-id/types';

import { EChartSeries } from '../types/series';

export const getSeriesTextMap: Partial<Record<EChartSeries, string>> = {
  [EChartSeries.CANDLESTICK]: 'Candlestick',
  [EChartSeries.LINE]: 'Line'
};

export const seriesToTestIdMap: Record<EChartSeries, EDataTestId> = {
  [EChartSeries.LINE]: EDataTestId.CHART_SERIES_OPTION_LINE,
  [EChartSeries.LINE_ASK]: EDataTestId.CHART_SERIES_OPTION_LINE_ASK,
  [EChartSeries.CANDLESTICK]: EDataTestId.CHART_SERIES_OPTION_CANDLESTICK
};
